import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Apply from "./pages/Apply";
import Login from "./pages/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import DealBuilder from "./pages/admin/DealBuilder";
import DealDetail from "./pages/admin/DealDetail";
import Applications from "./pages/admin/Applications";
import Team from "./pages/admin/Team";
import Settings from "./pages/admin/Settings";
import MerchantOffer from "./pages/merchant/MerchantOffer";

function Protected({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready)
    return (
      <div className="theme-admin min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/login" element={<Login />} />
          <Route path="/offer/:token" element={<MerchantOffer />} />
          <Route
            path="/admin"
            element={
              <Protected>
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="deals/new" element={<DealBuilder />} />
            <Route path="deals/:id/edit" element={<DealBuilder />} />
            <Route path="deals/:id" element={<DealDetail />} />
            <Route path="applications" element={<Applications />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
